import { cUtil } from "../../functions/util";

export class cAdminAccountAddress {

  div_message               = document.createElement('div');
  h3_shipping               = document.createElement('h3');
  p_shipping                = document.createElement('p');
  input_shippingFirstName   = document.createElement('input');
  input_shippingLastName    = document.createElement('input');
  label_shippingFirstName   = document.createElement('label');
  label_shippingLastName    = document.createElement('label');
  input_shippingCompany     = document.createElement('input');
  input_shippingAddress1    = document.createElement('input');
  input_shippingAddress2    = document.createElement('input');
  input_shippingCity        = document.createElement('input');
  input_shippingPostcode    = document.createElement('input');
  input_shippingCountry     = document.createElement('input');
  label_shippingCompany     = document.createElement('label');
  label_shippingAddress1    = document.createElement('label');
  label_shippingAddress2    = document.createElement('label');
  label_shippingCity        = document.createElement('label');
  label_shippingPostcode    = document.createElement('label');
  label_shippingCountry     = document.createElement('label');
  input_billingFirstName    = document.createElement('input');
  input_billingLastName     = document.createElement('input');
  label_billingFirstName    = document.createElement('label');
  label_billingLastName     = document.createElement('label');
  input_billingCompany      = document.createElement('input');
  input_billingAddress1     = document.createElement('input');
  input_billingAddress2     = document.createElement('input');
  input_billingCity         = document.createElement('input');
  input_billingPostcode     = document.createElement('input');
  input_billingCountry      = document.createElement('input');
  label_billingCompany      = document.createElement('label');
  label_billingAddress1     = document.createElement('label');
  label_billingAddress2     = document.createElement('label');
  label_billingCity         = document.createElement('label');
  label_billingPostcode     = document.createElement('label');
  label_billingCountry      = document.createElement('label');
  h3_billing                = document.createElement('h3');
  p_billing                 = document.createElement('p');
  button_save               = document.createElement('button');
  parent                    = document.querySelector('.c-account-customer-address')        as HTMLElement;
  script_json               = document.querySelector('.c-account-customer-address script') as HTMLScriptElement;

  input : AddressChange;

  constructor() {

    this.input = JSON.parse(this.script_json.textContent) as AddressChange;

     // ---- Structure ----
     this.parent.append(this.div_message);
     this.parent.append(this.h3_shipping);
     if (this.input.inStatusVerwaltet) {
       this.parent.append(this.p_shipping);
     }
     this.parent.append(this.label_shippingFirstName);
     this.parent.append(this.input_shippingFirstName);
     this.parent.append(this.label_shippingLastName);
     this.parent.append(this.input_shippingLastName);
     this.parent.append(this.label_shippingCompany);
     this.parent.append(this.input_shippingCompany);
     this.parent.append(this.label_shippingAddress1);
     this.parent.append(this.input_shippingAddress1);
     this.parent.append(this.label_shippingAddress2);
     this.parent.append(this.input_shippingAddress2);
     this.parent.append(this.label_shippingCity);
     this.parent.append(this.input_shippingCity);
     this.parent.append(this.label_shippingPostcode);
     this.parent.append(this.input_shippingPostcode);
     this.parent.append(this.label_shippingCountry);
     this.parent.append(this.input_shippingCountry);
     this.parent.append(this.h3_billing);
     if (this.input.inStatusVerwaltet) {
      this.parent.append(this.p_billing);
     }
     this.parent.append(this.label_billingFirstName);
     this.parent.append(this.input_billingFirstName);
     this.parent.append(this.label_billingLastName);
     this.parent.append(this.input_billingLastName);
     this.parent.append(this.label_billingCompany);
     this.parent.append(this.input_billingCompany);
     this.parent.append(this.label_billingAddress1);
     this.parent.append(this.input_billingAddress1);
     this.parent.append(this.label_billingAddress2);
     this.parent.append(this.input_billingAddress2);
     this.parent.append(this.label_billingCity);
     this.parent.append(this.input_billingCity);
     this.parent.append(this.label_billingPostcode);
     this.parent.append(this.input_billingPostcode);
     this.parent.append(this.label_billingCountry);
     this.parent.append(this.input_billingCountry);
     this.parent.append(this.button_save);

     // ---- Texts ----
     const { __, _x, _n, sprintf } = wp.i18n as i18n;
     this.label_shippingFirstName .textContent= __('Vorname'     , 'custom');
     this.label_shippingLastName  .textContent = __('Nachname'    , 'custom');
     this.label_shippingCompany   .textContent = __('Firmenname'  , 'custom');
     this.label_shippingAddress1  .textContent = __('Adresse'     , 'custom');
     this.label_shippingAddress2  .textContent = __('Adresszusatz', 'custom');
     this.label_shippingCity      .textContent = __('Ort'         , 'custom');
     this.label_shippingPostcode  .textContent = __('PLZ'         , 'custom');
     this.label_shippingCountry   .textContent = __('Land'        , 'custom');
     this.label_billingFirstName  .textContent = __('Vorname'     , 'custom');
     this.label_billingLastName   .textContent = __('Nachname'    , 'custom');
     this.label_billingCompany    .textContent = __('Firmenname'  , 'custom');
     this.label_billingAddress1   .textContent = __('Adresse'     , 'custom');
     this.label_billingAddress2   .textContent = __('Adresszusatz', 'custom');
     this.label_billingCity       .textContent = __('Ort'         , 'custom');
     this.label_billingPostcode   .textContent = __('PLZ'         , 'custom');
     this.label_billingCountry    .textContent = __('Land'        , 'custom');
     this.h3_shipping             .textContent = __('Lieferadresse'   , 'custom');
     this.h3_billing              .textContent = __('Rechnungsadresse', 'custom');
     this.p_shipping              .textContent = __('Diese Einstellungen sind erst aktiv, nachdem sie von Grauwiler 1821 AG bestätigt worden sind.', 'custom');
     this.p_billing               .textContent = __('Diese Einstellungen sind erst aktiv, nachdem sie von Grauwiler 1821 AG bestätigt worden sind.', 'custom');
     this.button_save             .textContent = __('Speichern', 'custom');

    // ---- Label Ids ----
    cUtil.labelIds(this.label_shippingFirstName, this.input_shippingFirstName);
    cUtil.labelIds(this.label_shippingLastName , this.input_shippingLastName);
    cUtil.labelIds(this.label_shippingCompany  , this.input_shippingCompany);
    cUtil.labelIds(this.label_shippingAddress1, this.input_shippingAddress1);
    cUtil.labelIds(this.label_shippingAddress2, this.input_shippingAddress2);
    cUtil.labelIds(this.label_shippingCity    , this.input_shippingCity);
    cUtil.labelIds(this.label_shippingPostcode, this.input_shippingPostcode);
    cUtil.labelIds(this.label_shippingCountry , this.input_shippingCountry);
    cUtil.labelIds(this.label_billingFirstName, this.input_billingFirstName);
    cUtil.labelIds(this.label_billingLastName , this.input_billingLastName);
    cUtil.labelIds(this.label_billingCompany  , this.input_billingCompany);
    cUtil.labelIds(this.label_billingAddress1 , this.input_billingAddress1);
    cUtil.labelIds(this.label_billingAddress2 , this.input_billingAddress2);
    cUtil.labelIds(this.label_billingCity     , this.input_billingCity);
    cUtil.labelIds(this.label_billingPostcode , this.input_billingPostcode);
    cUtil.labelIds(this.label_billingCountry  , this.input_billingCountry);


    // ---- Other ----
    this.input_shippingFirstName.type= 'text';
    this.input_shippingLastName.type = 'text';
    this.input_shippingCompany.type  = 'text';
    this.input_shippingAddress1.type = 'text';
    this.input_shippingAddress2.type = 'text';
    this.input_shippingCity.type     = 'text';
    this.input_shippingPostcode.type = 'text';
    this.input_shippingCountry.type  = 'text';
    this.input_billingFirstName.type = 'text';
    this.input_billingLastName.type  = 'text';
    this.input_billingCompany.type   = 'text';
    this.input_billingAddress1.type  = 'text';
    this.input_billingAddress2.type  = 'text';
    this.input_billingCity.type      = 'text';
    this.input_billingPostcode.type  = 'text';
    this.input_billingCountry.type   = 'text';

    this.input_shippingFirstName.maxLength= 255;
    this.input_shippingLastName.maxLength = 255;
    this.input_shippingCompany.maxLength  = 255;
    this.input_shippingAddress1.maxLength = 255;
    this.input_shippingAddress2.maxLength = 255;
    this.input_shippingCity.maxLength     = 255;
    this.input_shippingPostcode.maxLength = 255;
    this.input_shippingCountry.maxLength  = 255;
    this.input_billingFirstName.maxLength = 255;
    this.input_billingLastName.maxLength  = 255;
    this.input_billingCompany.maxLength   = 255;
    this.input_billingAddress1.maxLength  = 255;
    this.input_billingAddress2.maxLength  = 255;
    this.input_billingCity.maxLength      = 255;
    this.input_billingPostcode.maxLength  = 255;
    this.input_billingCountry.maxLength   = 255;

    this.button_save.type = 'button';
    this.button_save.classList.add('c-button-simple');

    // --- init ---
    this.input_shippingFirstName.value= this.input.address.shipping_first_name;
    this.input_shippingLastName.value = this.input.address.shipping_last_name;
    this.input_shippingCompany.value  = this.input.address.shipping_company;
    this.input_shippingAddress1.value = this.input.address.shipping_address_1;
    this.input_shippingAddress2.value = this.input.address.shipping_address_2;
    this.input_shippingCity.value     = this.input.address.shipping_city;
    this.input_shippingPostcode.value = this.input.address.shipping_postcode;
    this.input_shippingCountry.value  = this.input.address.shipping_country;
    this.input_billingFirstName.value = this.input.address.billing_first_name;
    this.input_billingLastName.value  = this.input.address.billing_last_name;
    this.input_billingCompany.value   = this.input.address.billing_company;
    this.input_billingAddress1.value  = this.input.address.billing_address_1;
    this.input_billingAddress2.value  = this.input.address.billing_address_2;
    this.input_billingCity.value      = this.input.address.billing_city;
    this.input_billingPostcode.value  = this.input.address.billing_postcode;
    this.input_billingCountry.value   = this.input.address.billing_country;

    this.button_save.addEventListener('click', async () => {

      this.input.address.shipping_first_name= this.input_shippingFirstName.value;
      this.input.address.shipping_last_name = this.input_shippingLastName.value;
      this.input.address.shipping_company   = this.input_shippingCompany.value;
      this.input.address.shipping_address_1 = this.input_shippingAddress1.value;
      this.input.address.shipping_address_2 = this.input_shippingAddress2.value;
      this.input.address.shipping_city      = this.input_shippingCity.value;
      this.input.address.shipping_postcode  = this.input_shippingPostcode.value;
      this.input.address.shipping_country   = this.input_shippingCountry.value;
      this.input.address.billing_first_name = this.input_billingFirstName.value;
      this.input.address.billing_last_name  = this.input_billingLastName.value;
      this.input.address.billing_company    = this.input_billingCompany.value;
      this.input.address.billing_address_1  = this.input_billingAddress1.value;
      this.input.address.billing_address_2  = this.input_billingAddress2.value;
      this.input.address.billing_city       = this.input_billingCity.value;
      this.input.address.billing_postcode   = this.input_billingPostcode.value;
      this.input.address.billing_country    = this.input_billingCountry.value;


      const data    = JSON.stringify(this.input);
      const message = await this.fetch(data, 'c_update_address')
      this.div_message.textContent = message.valueOf();
      this.div_message.classList.add('c-success');
    })
  }

  
  async fetch(data: string, action: string): Promise<String> {
    const  formData = new FormData();
    formData.append('_ajax_nonce', this.input.nonce);
    formData.append('action'     , action);
    formData.append('data'       , data);
  
    const response = await fetch('/wp-admin/admin-ajax.php', {
      method: 'POST',
      body: formData
    });
    const responseData = await response.json();
    return responseData;
  }

}